const leader = {
	GET_LEADER: "leader/get",
}

export default leader
